export default "__VITE_ASSET__b517d295__"